// extracted by mini-css-extract-plugin
export default {"spanStyle":"FolderStyle_spanStyle__84Fat","topIconImage":"FolderStyle_topIconImage__lwbo6"};